const amenities = [
    {
        descripiton: 'amenity',
        image: 'https://res.cloudinary.com/carronadepark/image/upload/v1611285585/Gallery/IMG_1715_Large_otojvp.jpg'
    },
    {
        descripiton: 'amenity',
        image: 'https://res.cloudinary.com/carronadepark/image/upload/v1611285585/Gallery/IMG_1716_Large_s75upg.jpg'
    },
    {
        descripiton: 'amenity',
        image: 'https://res.cloudinary.com/carronadepark/image/upload/v1611285585/Gallery/IMG_1653_Large_psjvht.jpg'
    },
    {
        descripiton: 'amenity',
        image: 'https://res.cloudinary.com/carronadepark/image/upload/v1611285586/Gallery/IMG_1654_Large_wey2ri.jpg'
    }
]

export default amenities;